import React from 'react';

import { Resources } from '@ragu-components/ord-resources';

import type { OrdResourceProps } from '@ragu-components/ord-resources';
import type { CallflowRead } from '@ragu-components/ord-types';

const Dialplan = React.lazy(async () => import('./Dialplan'));

export const callflowsResource: OrdResourceProps = {
  key: Resources.callflows,
  name: Resources.callflows,
  list: <Dialplan />,
  recordRepresentation: (record: CallflowRead): string => record.name,
};
